// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3382":"27e1b0d7af7689e7","8223":"1502b5b19b0e9217"}[chunkId] + ".css";
};